import LocationsTableReducer from "./reducers/LocationsTableReducer";
import LocationsSaga from "./saga";

import IConfig from "interfaces/IConfig";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";
import DatatransUpdateModal from "./components/modules/Datatrans/modals/DatatransUpdateModal";
import GastroPayActivateModal from "./components/modules/GastroPay/modals/GastroPayActivateModal";
import GastroPayUpdateModal from "./components/modules/GastroPay/modals/GastroPayUpdateModal";
import OrderLocationSelectModal from "./modals/OrderLocationSelectModal";

export const moduleName = "Order.locations";
export const url = "locations";
export const groupsUrl = `${url}/groups`;

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["order.locations.read"]) {
        config.active = true;

        store.reducerManager?.add("OrderLocationTable", LocationsTableReducer);
        store.injectSaga?.("OrderLocationsSaga", LocationsSaga);
        registerModals({
            OrderLocationSelectModal,
        });
        routing.push({
            path: url,
            element: (
                <AsyncComponent path="Order/Locations/pages/LocationsIndexPage" />
            ),
        });
    }

    if (permissions["order.locations.update"]) {
        routing.push({
            path: `${url}/:id/edit`,
            element: (
                <AsyncComponent path="Order/Locations/pages/LocationsEditPage" />
            ),
        });
    }

    if (permissions["order.tenant_modules.create"]) {
        registerModals({ GastroPayActivateModal });
    }
    if (permissions["order.tenant_modules.update"]) {
        registerModals({ GastroPayUpdateModal });
        registerModals({ DatatransUpdateModal });
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
